import React from 'react'
import { object, array, func } from 'prop-types'
import { injectIntl } from 'react-intl'
import { Container, Content } from 'src/components/Layout'
import { Flex, Box } from '@chakra-ui/react'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon'
import Button from 'src/components/Button/Button'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'
import './UploadPreview.less'
import intlMessagesApp from 'src/modules/App/translations'

class UploadPreview extends React.Component {
  constructor(props) {
    super(props)

    const { files } = this.props

    this.state = {
      activeFile: files.find(this.findFileCallback),
    }
  }

  findFileCallback = f => {
    const { file } = this.props
    if (f.id) {
      return f.id === file.id
    } else if (file.uid) {
      return f.uid === file.uid
    } else {
      // only frontend pictures. they don't have id field instead stateId
      return f.stateId === file.stateId
    }
  }

  handleOnSlide = (filesForSlider, index) => {
    if (filesForSlider.hasOwnProperty(index)) {
      this.setState({
        activeFile: filesForSlider[index],
      })
    }
  }

  handleDelete = () => {
    const { onDelete } = this.props
    const { activeFile } = this.state

    if (activeFile && typeof onDelete === 'function') {
      onDelete(activeFile)
    }
  }

  handleCancel = () => {
    const { onCancel } = this.props

    if (typeof onCancel === 'function') {
      onCancel()
    }
  }

  render() {
    const { intl, files, isWidget } = this.props

    const { activeFile } = this.state

    // Add additional data for slider
    const filesForSlider = files.map(f => {
      if (!(f.hasOwnProperty('url') && f.url)) {
        return false
      }

      return {
        ...f,
        original: f.url,
        originalAlt: 'user uploaded image',
      }
    })

    const activeIndex = filesForSlider.findIndex(this.findFileCallback) || 0

    return (
      <Flex>
        <Content>
          <Container style={{ backgroundColor: '#fff' }}>
            {filesForSlider && filesForSlider.length > 0 ? (
              <Box mt={'40px'}>
                <ImageGallery
                  items={filesForSlider}
                  showNav={isWidget === true}
                  showThumbnails={false}
                  showFullscreenButton={false}
                  showPlayButton={false}
                  showBullets={true}
                  showIndex={true}
                  indexSeparator={'/'}
                  startIndex={activeIndex}
                  onSlide={index => this.handleOnSlide(filesForSlider, index)}
                />
              </Box>
            ) : (
              ''
            )}
            <Flex direction={{ base: 'column', lg: 'row' }} justify='center'>
              <Button
                mr={{ base: 0, lg: '20px' }}
                mb={{ base: '20px', lg: '0' }}
                onClick={this.handleDelete}
              >
                <Box mr={'10px'}>
                  <FontAwesomeIconComponent icon={['far', 'trash']} size='xs' type='white' />
                </Box>
                {intl.formatMessage(intlMessagesApp.appGlobalRemove)}
              </Button>
              <Button onClick={() => window.open(activeFile.url, '_blank')}>
                <Box mr={'10px'}>
                  <FontAwesomeIconComponent icon={['far', 'download']} size='xs' type='white' />
                </Box>
                {intl.formatMessage(intlMessagesApp.appGlobalDownload)}
              </Button>
            </Flex>
          </Container>
        </Content>
      </Flex>
    )
  }
}

UploadPreview.propTypes = {
  renderPageTitle: func,
  file: object.isRequired,
  files: array.isRequired,
  onDelete: func,
  onCancel: func,
}

export default injectIntl(UploadPreview)
